import { makeStyles } from '@material-ui/core/styles';

export default makeStyles((theme) => ({
  section: {
    width: '100%',
    padding: theme.spacing(1, 0, 2),
  },
  paperActions: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
  },
  // O cabeçalho do Paper é flex: sem alinhar, o botão estica até a altura do título.
  smallButton: {
    alignSelf: 'center',
    fontSize: '0.75rem',
    padding: '5px 14px',
    minHeight: 0,
    lineHeight: 1.6,
    boxShadow: 'none',
  },
  help: {
    color: 'rgba(0, 0, 0, 0.54)',
    fontSize: '0.8rem',
    marginTop: theme.spacing(0.5),
  },
  table: {
    'marginTop': theme.spacing(2),
    '& th': {
      fontWeight: 600,
      color: 'rgba(0, 0, 0, 0.6)',
      whiteSpace: 'nowrap',
    },
  },
  highlightRow: {
    '& td': {
      fontWeight: 600,
      color: theme.palette.green.main,
    },
  },
  inlineProgress: {
    marginLeft: theme.spacing(1),
    verticalAlign: 'middle',
  },
  filterRow: {
    padding: theme.spacing(0, 0, 1),
  },
  batchRow: {
    display: 'flex',
    alignItems: 'flex-end',
    gap: theme.spacing(2),
    margin: theme.spacing(2, 0, 0),
  },
  batchField: {
    width: 200,
  },
  // Declarado depois de smallButton para vencer o alignSelf: center e descer até a linha do campo.
  batchButton: {
    whiteSpace: 'nowrap',
    flexShrink: 0,
    alignSelf: 'flex-end',
    marginBottom: theme.spacing(1),
  },
  headCell: {
    fontWeight: 'bold',
    whiteSpace: 'nowrap',
  },
  row: {
    whiteSpace: 'nowrap',
  },
}));
